<template>
  <v-dialog width="350px" persistent v-model="editDialog">
    <v-btn  slot="activator" icon class="">
      <v-icon small light class="text--lighten-1">edit</v-icon>
    </v-btn>
    <v-card>
      <v-container class="mt-0">
        <v-layout row wrap>
          <v-flex xs12 class="mb-2">
            <v-card-title class="justify-center"><h2>Edit Trial Investigators</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedInvestigators" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12>
              <v-text-field
                v-model="editedInvestigators"
                label="Investigator"
                id="InvestigatorName"
              ></v-text-field>
              <v-text-field
                v-model="editedInvestigatorsPhone"
                label="Investigator Phone Number"
                id="InvestigatorPhone"
              ></v-text-field>
              <v-text-field
                v-model="editedInvestigatorsEmail"
                label="Investigator Email Address"
                id="InvestigatorEmail"
              ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
              <v-btn dark flat class="red darken-3" @click="onDeleteInvestigator(investigator)"><v-icon small dark class="text--lighten-1">delete</v-icon></v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['investigator'],
  data () {
    return {
      editDialog: false,
      editedInvestigators: this.investigator.investigatorName,
      editedInvestigatorsPhone: this.investigator.investigatorPhone,
      editedInvestigatorsEmail: this.investigator.investigatorEmail
    }
  },
  computed: {
    loadInvestigators () {
      return this.$store.getters.loadedInvestigators
    }
  },
  methods: {
    onDeleteInvestigator (investigator) {
      console.log('Delete this: ' + JSON.stringify(investigator))
      this.$store.dispatch('deleteInvestigatorData', investigator)
      this.$router.push('/investigators')
    },
    onSaveChanges () {
      this.editDialog = false
      this.$store.dispatch('updateInvestigatorData', {
        investigatorId: this.investigator.investigatorId,
        investigatorName: this.editedInvestigators,
        investigatorPhone: this.editedInvestigatorsPhone,
        investigatorEmail: this.editedInvestigatorsEmail
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditInvestigatorsDialog.vue?9369c5f4